// removed by extract-text-webpack-plugin
module.exports = {"goodIn":"wmf-1fdGkAl8","search":"wmf-mG7W5vo8","goodBody":"wmf-3VKsiXLh","page":"wmf-3oKRzdT0","commodity_goods_style":"wmf-2pz5W1Na","trend_title":"wmf-67VRR1AF"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/salesreport/salesoverview/sales-overview.module.less
// module id = 3892
// module chunks = 0